import Os248 from '/src/_includes/backward-incompatible-changes/open-source/2.4.7-2.4.8.md';
import Os247 from '/src/_includes/backward-incompatible-changes/open-source/2.4.6-2.4.7.md';
import Os246 from '/src/_includes/backward-incompatible-changes/open-source/2.4.5-2.4.6.md';
import Docs20 from '/src/_includes/backward-incompatible-changes/open-source/2.4.4-2.4.5.md';
import Docs17 from '/src/_includes/backward-incompatible-changes/open-source/2.4.3-2.4.4.md';
import * as React from 'react';
export default {
  Os248,
  Os247,
  Os246,
  Docs20,
  Docs17,
  React
};